module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n  " + _vm._s(_vm.valueStr) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5011f795!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/animate-number/animate-number.vue
// module id = 248
// module chunks = 32